module.exports = __webpack_public_path__ + "static/media/dominosIcon.5cbb0d24.png";